import React from 'react';
import styled from 'styled-components';
import Label, { LabelFontFamily } from '../../../components/Label';
import { IndentWidthType } from '../../../types';
const DocsPageContentText = ({ text, fontFamily = LabelFontFamily.FONT_FAMILY_REGULAR, withIndent = IndentWidthType.NONE, ...rest }) => {
    return React.createElement(DocsPageContentTextWrapper, { text: text, fontFamily: fontFamily, withIndent: withIndent, ...rest }, text);
};
export default DocsPageContentText;
const DocsPageContentTextWrapper = styled(Label) `
  display: inline;

  font-size: 16px;
  line-height: 22px;

  padding-left: 0px;
  padding-left: ${props => props.withIndent === IndentWidthType.NONE && '0px'};
  padding-left: ${props => props.withIndent === IndentWidthType.SMALL && '50px'};
  padding-left: ${props => props.withIndent === IndentWidthType.MEDIUM && '100px'};
  padding-left: ${props => props.withIndent === IndentWidthType.LARGE && '150px'};

  color: ${props => props.theme.colors.blackLight};
`;
//# sourceMappingURL=DocsPageContentText.js.map